import * as actionTypes from "../action-types";

export const getRevenueSettings = payload => ({ type: actionTypes.GET_REVENUE_SETTINGS, payload });
export const setRevenueSettings = payload => ({ type: actionTypes.SET_REVENUE_SETTINGS, payload });
export const updateRevenueSettings = payload => ({ type: actionTypes.UPDATE_REVENUE_SETTINGS, payload });
export const getRevenueRecords = payload => ({ type: actionTypes.GET_REVENUE_RECORDS, payload });
export const setRevenueRecords = payload => ({ type: actionTypes.SET_REVENUE_RECORDS, payload });
